import area from './area'
import layout from './layout'
import landing from './landing'
import splash from './splash'
import theme from './theme'
import page from './page'

export default {
  name: 'Content',
  path: 'content',
  meta: {
    label: 'cms',
    auth: 'cms'
  },
  component: {
    name: 'Content',
    render(c) {
      return c('router-view')
    }
  },
  children: [page, area, layout, splash, landing, theme]
}
